import { WatcherFunction } from '..'
import { watchFetchCategoriesRequest } from './list'

export const categoriesSagas: ReadonlyArray<WatcherFunction> = [watchFetchCategoriesRequest]
